// ** Third Party Imports
import { createSlice } from '@reduxjs/toolkit'

// ** Action Imports
import { sessionApi } from '@/entities/session/api/sessionApi'
import { loginThunk } from '@/features/auth/login'
import { currentUserThunk } from '../model/currentUserThunk'
import { getCurrentUserApi } from '../api/getCurrentUser'

// ** Type Imports
import { type UserDTO } from './types'

interface UserState {
	user: UserDTO | null
}

const initialState: UserState = {
	user: null
}

const currentUserSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		setCurrentUser: (state, action) => {
			state.user = action.payload
		}
	},
	extraReducers: (build) => {
		build.addCase(loginThunk.fulfilled, (state, { payload }) => {
			state.user = payload || null
		})
		build.addCase(currentUserThunk.fulfilled, (state, { payload }) => {
			state.user = payload || null
		})
		// any `/users/me` refetch (e.g. after invalidating TAGS.ME) refreshes the
		// stored user too, so free-plan usage and access stay current
		build.addMatcher(
			getCurrentUserApi.endpoints.getCurrentUser.matchFulfilled,
			(state, { payload }) => {
				state.user = payload
			}
		)
		build.addMatcher(sessionApi.endpoints.logout.matchFulfilled, (state) => {
			state.user = null
		})
	}
})

export const { setCurrentUser } = currentUserSlice.actions

export const currentUserReducer = currentUserSlice.reducer
